import module from 'recursoshumanos/module.js'
import template from './template.html'
import * as moment from 'moment'
import { isArray, isDate, isFinite, isString } from 'lodash'

export class RecursoshumanosVisorlotesComponent {
  idEmpresa
  clase
  proyectos
  fecha
  registroPatronalId
  lotes = null
  buscando = false

  constructor ($location, RecursosHumanosVisorLotes) {
    this.$location = $location
    this.RecursosHumanosVisorLotes = RecursosHumanosVisorLotes
  }

  $onInit () {
    this.buscar()
  }

  configurar ({idEmpresa, clase, proyectos, fecha, registroPatronalId}) {
    this.idEmpresa = idEmpresa
    this.clase = clase
    this.registroPatronalId = registroPatronalId
    this.proyectos = proyectos
    this.fecha = fecha
    this.$location.search({id_empresa: idEmpresa, clase, proyectos, fecha: moment(fecha).format('YYYY-MM-DD'), registroPatronalId})
    this.$location.replace()
  }

  buscar () {
    if (this.buscando) return
    if (!isString(this.idEmpresa) || !isFinite(this.clase) || !isArray(this.proyectos) || !isDate(this.fecha)) return

    this.buscando = true
    this.lotes = null

    this.RecursosHumanosVisorLotes.get(this.idEmpresa, this.clase, this.proyectos, this.fecha, this.registroPatronalId)
      .then(({data}) => (this.lotes = data))
      .finally(() => (this.buscando = false))
  }
}

module.component('recursoshumanosVisorlotes', {
  controller: RecursoshumanosVisorlotesComponent,
  template,
  bindings: {
    idEmpresa: '<',
    clase: '<',
    proyectos: '<',
    registroPatronalId: '<',
    fecha: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/component.js